module.exports = __webpack_public_path__ + "img/img37.b069cbc0.svg";